module.exports = __webpack_public_path__ + "img/wangwei.821b807b.png";